import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { openNotification } from 'apps/web/builder/slice/notification.slice';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';

import { register } from '../api';

export default function useRegister() {
  const dispatch = useDispatch();
  const router = useRouter();

  const currentQuery = router.query;

  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    phoneNumber: '',
    workspaceName: '',
    password: '',
    passwordConfirm: '',
  });

  const handleChangeValue = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;

    setUser({ ...user, [name]: value });
  };

  const { mutate } = useMutation({
    mutationKey: ['register'],
    mutationFn: async () => {
      const payload = {
        fullName: `${user.firstName} ${user.lastName}`,
        email: user.email,
        password: user.password,
        workspaceName: currentQuery.workspace,
        workspaceId: currentQuery.workspaceId,
        token: currentQuery.token,
      };

      const response = await register(payload);
      return response;
    },
    onSuccess(response) {
      if (response.id) {
        setUser({
          firstName: '',
          lastName: '',
          username: '',
          email: '',
          phoneNumber: '',
          workspaceName: '',
          password: '',
          passwordConfirm: '',
        });
        dispatch(
          openNotification({
            type: 'success',
            title: 'Success register',
          })
        );
        setTimeout(() => {
          router.push('/');
        }, 2000);
      }

      response?.statusCode === 400 &&
        dispatch(openNotification({ type: 'error', title: response.message }));

      response?.code === 100 &&
        dispatch(
          openNotification({
            type: 'error',
            title: response.error_user_title ?? response.message,
            description: response.error_user_msg ?? '',
          })
        );
    },
  });

  return { user, setUser, handleChangeValue, register: mutate };
}
